var PrescriptionSide;
(function(PrescriptionSide) {
    PrescriptionSide["Right"] = 'rightEye';
    PrescriptionSide["Left"] = 'leftEye';
})(PrescriptionSide || (PrescriptionSide = {}));
var PrescriptionKey;
(function(PrescriptionKey) {
    PrescriptionKey["Power"] = 'power';
    PrescriptionKey["Axis"] = 'axis';
    PrescriptionKey["Cylinder"] = 'cylinder';
    PrescriptionKey["Addition"] = 'addition';
    PrescriptionKey["BaseCurve"] = 'baseCurve';
    PrescriptionKey["Diameter"] = 'diameter';
    PrescriptionKey["PupillaryDistance"] = 'pupillaryDistance';
    PrescriptionKey["Prism"] = 'prism';
})(PrescriptionKey || (PrescriptionKey = {}));

export { PrescriptionKey, PrescriptionSide };
//# sourceMappingURL=types.js.map
